import { fromTimeZoneToUTC, toDate, toISOString } from '@gogame/intl-ts';
import { object, string, number, collection, boolean } from '@gogame/schemas';

import {
  TYPE,
  PERIODS,
  PERIOD,
  PERIOD_END_DATE,
  PERIOD_START_DATE,
  RATE,
  RATE_CURRENCY,
  RATE_VALUE,
  FINANCIAL_RESULT_ID,
  IS_READONLY,
  IS_FINISH_DATE_REQUIRED,
  TYPE_ID,
  IS_FUTURE_COST_MODEL,
  IS_UNRESTRICTED_DATES,
  IS_REMOVABLE,
  CURRENCY_USD,
  EVENT,
  CPE_ID,
  CAMPAIGN_TYPE_ID,
  CAMPAIGN_TYPE,
  ACTIVITY_TYPE,
} from './constants';

export const toISO = (value) => toISOString(fromTimeZoneToUTC(value));

export const periodSchema = object({
  [PERIOD_START_DATE]: string().required('Start date is required'),
  [PERIOD_END_DATE]: string().when(
    ['$addNewPeriod', '$maxDate', '$finishDateRequired', '$unrestrictedDates'],
    (addNewPeriod, maxDate, finishDateRequired, unrestrictedDates, schema) => {
      return addNewPeriod
        ? schema.required().test('maxDate', '', (value) => {
            if (unrestrictedDates) {
              return true;
            }
            if (finishDateRequired) {
              return toDate(new Date(value)) < toDate(new Date(maxDate));
            }
            return toDate(new Date(value)) <= toDate(new Date(maxDate));
          })
        : schema;
    }
  ),
}).default({});

export const rateSchema = object({
  [RATE_CURRENCY]: string().required('Currency is required'),
  [RATE_VALUE]: number().required('Rate is required'),
}).default({
  [RATE_CURRENCY]: CURRENCY_USD,
});

export const costModelPeriodSchema = object({
  [PERIOD]: periodSchema,
  [RATE]: rateSchema,
  [IS_READONLY]: boolean().when(
    '$stripPeriodReadonly',
    ($stripPeriodReadonly, schema) =>
      $stripPeriodReadonly ? schema.strip() : schema
  ),
  [ACTIVITY_TYPE]: number(),
  [FINANCIAL_RESULT_ID]: number().when(
    '$stripPeriodFinancialResultId',
    (stripFinancialResultId, schema) =>
      stripFinancialResultId ? schema.strip() : schema
  ),
});

export const costModelTypeSchema = object({
  [TYPE_ID]: number(),
  [IS_FINISH_DATE_REQUIRED]: boolean(),
  [IS_FUTURE_COST_MODEL]: boolean(),
  [IS_UNRESTRICTED_DATES]: boolean(),
  [IS_REMOVABLE]: boolean(),
});

const eventSchema = object().shape({
  id: number().required('Event is required'),
  name: string().required('Event is required'),
});

export const costModelSchema = object({
  [TYPE]: costModelTypeSchema,
  [PERIODS]: collection(costModelPeriodSchema).default([
    costModelPeriodSchema.default(),
  ]),
  [EVENT]: object().when(`${CAMPAIGN_TYPE}.${CAMPAIGN_TYPE_ID}`, {
    is: CPE_ID,
    then: eventSchema,
  }),
});
